export function checkPermission(permission, allPermissions) {
  const permissions = allPermissions.filter((actualPermission) => {
    return actualPermission.name.includes(`-${permission}`);
  });
  const selected = permissions.filter((p) => p.name.endsWith("-" + permission));

  const response = {};

  selected.forEach((p) => {
    response[p.name.split("-")[0]] = p;
  });

  return response;
}
